import ApiService from '../api.services';

const InvoiceServices = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/invoice');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    addSingle: async function(data) {
        try {
            const response = await ApiService.post('/api/invoice/single', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    filter: async function (data) {
        try {
            const response = await ApiService.post('/api/invoice/filter', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    export: async function (id) {
        try {
            const response = await ApiService.post(`/api/invoice/export/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    pendencies: async function (data) {
        try {
            const response = await ApiService.post(`/api/invoice/pendencies`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    prepost: async function (data, type) {
        try {
            const response = await ApiService.post(`/api/invoice/pendencies/${data.customer}/${type}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (list, filter) {
        try {
            const data = {
                invoices: list,
                filter: filter
            }
            const response = await ApiService.post('/api/invoice', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    cnab: async function (list) {
        try {
            const data = {
                invoices: list
            }
            const response = await ApiService.post('/api/invoice/cnab', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        const data = {
            item: form
        }
        try {
            const response = await ApiService.put(`/api/items/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/items/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default InvoiceServices;

export { InvoiceServices };

